<template>
    <div class="banner">
        <div class="titulo text-white">
            <h2 class="text-white" style="font-size:50px">Conócenos más</h2>
            <h4 class="text-white" style="font-size:20px; margin-left: 100px;"><router-link to="/" class="text-white">Inicio</router-link> / Nosotros</h4>
        </div>
    </div>
    <div class="about-us-page">
        <section class="section about">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 d-flex align-items-center aos" data-aos="fade-up" style="width: 80%; margin: auto;">
                        <div class="about-content">
                            <p>
                                Somos Agrovision Perú, sede país de Agrovision Corp, corporación de origen 
                                estadounidense, una de las productoras de berries más grandes del mundo que 
                                busca redefinir la industria de la agricultura con el propósito de transformar 
                                tierras y transformar vidas.
                            </p>
                            <p class="mt-2 mb-2">
                                Somos una agroexportadora de gran crecimiento y alto impacto social que produce, 
                                empaca y exporta frutas y hortalizas premium de las mejores variedades de Arándano, 
                                Uva de mesa, Espárrago y Palto en Perú.
                            </p>
                            <p class="mt-4 mb-2">
                                Operamos con los más altos estándares de bienestar de los trabajadores y utilizamos 
                                tecnología para garantizar el más alto nivel de calidad, seguridad alimentaria y 
                                valor para nuestros clientes.
                            </p>
                            <p class="mt-2 mb-2">
                                Contamos con 2846 has cultivadas en el proyecto de irrigación Olmos y terrenos adyacentes. 
                                Nuestros fundos y sedes operativas se encuentran en Olmos y Mórrope; nuestras sedes 
                                administrativas, en Chiclayo, Lima y Los Ángeles.
                            </p>
                            <p class="mt-4 mb-2">
                                Estamos convencidos de que el talento impulsa la estrategia y nos permitirá alcanzar una 
                                evolución importante en cada sistema de la corporación. ¡Sembremos futuro juntos!
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-6 mt-5">
                        <div class="about-content-img aos" data-aos="zoom-in">
                            <img src="@/assets/img/happy-young-man.png" class="img-fluid" alt="img" />
                        </div>
                    </div>
                    <div class="col-lg-6 mt-5">
                        <div class="about-content-img aos" data-aos="zoom-in">
                            <img src="@/assets/img/happy-young-man.png" class="img-fluid" alt="img" />
                        </div>
                    </div>
                    <div class="col-lg-12 d-flex align-items-center aos" data-aos="fade-up" style="width: 80%; margin: auto;">
                        <div class="about-content">
                            <h2 class="header-title mt-5 mb-3">¿Por qué trabajar en Agrovisión?</h2>
                            <p class="mt-5 mb-5">
                                Agrovision es una corporación agroexportadora de frutas y verduras premium, líder en 
                                innovación que busca fortalecer una cultura única, y formar a sus colaboradores en 
                                liderazgo y trabajo en equipo.
                            </p>
                        </div>
                    </div>

                    <div class="row" data-aos="fade-up" aos-duration="700">
                        <div class="col-xl-4 col-md-6 col-sm-12">
                            <div class="footer-widget footer-menu">
                                <h2 class="footer-title" style="height: 50px;" >EMPRESA EXITOSA</h2>
                                <ul>
                                    <li><i class="fas fa-check me-1"></i>Crecimiento sostenible</li>
                                    <li><i class="fas fa-check me-1"></i>Expansión - exportación mercados globales</li>
                                    <li><i class="fas fa-check me-1"></i>Socialmente responsable</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12">
                            <div class="footer-widget footer-menu">
                                <h2 class="footer-title" style="height: 50px;" >LIDERES EN INNOVACION</h2>
                                <ul>
                                    <li><i class="fas fa-check me-1"></i>Innovación</li>
                                    <li><i class="fas fa-check me-1"></i>Genética</li>
                                    <li><i class="fas fa-check me-1"></i>Patentes</li>
                                    <li><i class="fas fa-check me-1"></i>Especialización</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12">
                            <div class="footer-widget footer-menu">
                                <h2 class="footer-title" style="height: 50px;" >EMPRESA DE BUENAS CONDICIONES LABORALES</h2>
                                <ul>
                                    <li><i class="fas fa-check me-1"></i>Condiciones/infraestructura</li>
                                    <li><i class="fas fa-check me-1"></i>Carga de trabajo</li>
                                    <li><i class="fas fa-check me-1"></i>Jornada y horario de trabajo</li>
                                    <li><i class="fas fa-check me-1"></i>Proyecto retador</li>
                                    <li><i class="fas fa-check me-1"></i>Remuneración/beneficios</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="row" data-aos="fade-up" aos-duration="700">
                        <div class="col-xl-4 col-md-6 col-sm-12">
                            <div class="footer-widget footer-menu">
                                <h2 class="footer-title" style="height: 50px;" >UN BUEN LUGAR PARA TRABAJAR</h2>
                                <ul>
                                    <li><i class="fas fa-check me-1"></i>Crecimiento sostenible</li>
                                    <li><i class="fas fa-check me-1"></i>Expansión - exportación mercados globales</li>
                                    <li><i class="fas fa-check me-1"></i>Socialmente responsable</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12">
                            <div class="footer-widget footer-menu">
                                <h2 class="footer-title" style="height: 50px;" >CULTURA</h2>
                                <ul>
                                    <li><i class="fas fa-check me-1"></i>Innovación</li>
                                    <li><i class="fas fa-check me-1"></i>Genética</li>
                                    <li><i class="fas fa-check me-1"></i>Patentes</li>
                                    <li><i class="fas fa-check me-1"></i>Especialización</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12">
                            <div class="footer-widget footer-menu">
                                <h2 class="footer-title" style="height: 50px;" >LIDERAZGO/TRABAJO EN EQUIPO</h2>
                                <ul>
                                    <li><i class="fas fa-check me-1"></i>Condiciones/infraestructura</li>
                                    <li><i class="fas fa-check me-1"></i>Carga de trabajo</li>
                                    <li><i class="fas fa-check me-1"></i>Jornada y horario de trabajo</li>
                                    <li><i class="fas fa-check me-1"></i>Proyecto retador</li>
                                    <li><i class="fas fa-check me-1"></i>Remuneración/beneficios</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 d-flex align-items-center aos" data-aos="fade-up" style="width: 80%; margin: auto;">
                        <div class="about-content">
                            <h4 class="header-title mt-5 mb-3">AGROVISION CLUB</h4>
                            <p class="mt-5 mb-5">
                                Programa de beneficios exclusivo para colaboradores de las empresas 
                                Agrovision y Arena Verde. Los mejores descuentos corporativos en 
                                establecimientos de educación, alimentos, bebidas, entretenimiento, 
                                viajes, hospedaje, cuidado, salud y comercio.
                            </p>
                            <p>
                                ¡Porque ser Agrovision es ser parte del crecimiento!
                            </p>

                            <div class="agv_club_cats">
                                <ul>
                                    <li><img src="@/assets/img/agv_club_cat_1.png" alt="img_agv_club_cat"></li>
                                    <li><img src="@/assets/img/agv_club_cat_2.png" alt="img_agv_club_cat"></li>
                                    <li><img src="@/assets/img/agv_club_cat_3.png" alt="img_agv_club_cat"></li>
                                    <li><img src="@/assets/img/agv_club_cat_4.png" alt="img_agv_club_cat"></li>
                                    <li><img src="@/assets/img/agv_club_cat_5.png" alt="img_agv_club_cat"></li>
                                    <li><img src="@/assets/img/agv_club_cat_6.png" alt="img_agv_club_cat"></li>
                                </ul>
                            </div>

                            <h4 class="header-title mt-5 mb-3">CUIDAMOS DE TU FAMILIA</h4>
                            <p class="mt-5 mb-5">
                                En Agrovision, estamos comprometidos con generar impacto positivo en 
                                las familias de nuestros colaboradores.
                            </p>

                            <div class="agv_seguros">
                                <ul>
                                    <li><img src="@/assets/img/agv_seguro_1.png" alt="img_agv_seguro"></li>
                                    <li><img src="@/assets/img/agv_seguro_2.png" alt="img_agv_seguro"></li>
                                    <li><img src="@/assets/img/agv_seguro_3.png" alt="img_agv_seguro"></li>
                                    <li><img src="@/assets/img/agv_seguro_4.png" alt="img_agv_seguro"></li>
                                    <li><img src="@/assets/img/agv_seguro_5.png" alt="img_agv_seguro"></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>
<style>
    .banner{
        width: 100%;
        height: 280px;
        background-image: url('../../../../assets/img/fondo_principal_inicio.png');
        background-size: contain;
        background-position: center bottom;
    }

    .banner::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 280px;
        background-color: rgba(0, 0, 0, 0.4); /* Color negro semi-transparente */
    }

    .titulo{
        position: absolute;
        top:130px;
        left: 50%;
        margin-left: -180px;
        z-index: 5;
    }

    .agv_club_cats{
        margin-top: 40px;
        margin-bottom: 20px;
    }

    .agv_club_cats ul,
    .agv_seguros ul{
        display: flex;
        list-style: none;
        flex-wrap: wrap;
        justify-content: center;
    }

    .agv_club_cats ul li,
    .agv_seguros ul li{
        width: 100px;
        margin: 5px;
    }
    
    .agv_club_cats ul li img,
    .agv_seguros ul li img{
        box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
        border-radius: 50%;
        background: #fff;
        width: 100%;
        border: 4px solid #fff;
    }
</style>


